import axiosInstance from '@server/axiosInstance';
import { deleteCookie, setCookie, getCookie } from '@utils/getCookie';
import { useMutation } from 'react-query';

import { loginBackRoute } from '../api/constant';

export const useLoginBack = () => {
  const { mutate: userLoginBack } = useMutation({
    mutationFn: (variables: { user_id: Number | string }) =>
      axiosInstance
        .get(
          `${loginBackRoute}${variables.user_id ? `?user_id=${variables.user_id}` : ''}`,
        )
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        // Delete cookies
        setCookie('SU_AUTH', null, 0);
        setCookie('SU_USER_TYPE', null, 0);
        setCookie('csrftoken', null, 0);
        setCookie('master_key', null, 0);
        setCookie('isNotificationPopupShown', null, 0);
        setCookie('hideJobClosedSuggestion', null, 0);
        setCookie('dontShowWarningPopup', null, 0);
        deleteCookie('csrftoken');
        deleteCookie('SU_USER_TYPE');
        deleteCookie('SU_AUTH');
        deleteCookie('master_key');
        deleteCookie('sessionid');
        deleteCookie('isNotificationPopupShown');
        deleteCookie('hideJobClosedSuggestion');
        deleteCookie('dontShowWarningPopup');
        deleteCookie('C_EMAIL');
        sessionStorage.removeItem('hireflixModalSeen');

        // Set new token
        setCookie('SU_AUTH', data.token, 5);
        setCookie('csrftoken', data.csrf_token, 5);
        setCookie('sessionid', data.session_id, 5);
        setCookie('SU_USER_TYPE', data.user, 5);
        // Redirect based on user type
        switch (data.user) {
          case 'applicant':
            window.location.href = '/applicants/';
            break;
          case 'company':
            window.location.href = '/dashboard/';
            break;
          case 'enterprise':
            window.location.href = '/enterprise/';
            break;
          case 'admin':
            window.location.href = '/admin/';
            break;
          default:
            // Handle unexpected user type
            break;
        }
      }
    },
    onError: (error: { message?: string }) => {
      // Handle error
    },
  });
  return {
    userLoginBack,
  };
};
